import { ClientTypes } from "@Context/types"

/**
 * Reducers - Information about the client's
 *
 * @version 1.0.1
 * @author Naldo Duran <naldorck@gmail.com>
 * @returns {function}
 */
const ClientReducer = (state, action) => {
  switch (action.type) {
    case ClientTypes.set_website:
      return {
        ...state,
        website: action.payload,
      }

    case ClientTypes.set_env:
      return {
        ...state,
        env: action.payload,
      }

    default:
      return state
  }
}

export default ClientReducer
